import { get } from 'lodash'
import { EventPages } from 'Event/redux/actions/EventNavigation'

export const getEventsPage = (state: any) => get(state, 'EventNavigation.page', EventPages.Calendar)
